import React from "react";
import marked from "marked";
import dompurify from "dompurify";
import {DynoFeatureModel} from "../../product-models";
import ProductFeature from "./ProductFeature";

interface ProductFeaturesProps {
    features: DynoFeatureModel[];
    localisedProductName: string;
}

const ProductFeatures = (props:ProductFeaturesProps) => {
    
    if(props.features == undefined) {
        return null;
    }
    
    return (
        <div className="product-features">
            {props.features.length > 0 && props.features.map((feature, index) => {
                return (
                    <ProductFeature 
                        key={feature.FeatureId} 
                        imageLocation={feature.ImageLocation}
                        id={feature.FeatureId}
                        title={feature.DynoTitle}
                        imagePath={feature.ImagePath}
                        videoPath={feature.VideoPath}
                        videoThumbImage={feature.VideoThumbImage}
                        isVideo={feature.IsVideo}
                        guid={feature.Guid}
                        textContent={feature.FeatureAsHtml}
                        footerNotes={feature.DynoFooterNotes}
                        localisedProductName={props.localisedProductName}
                    />
                )
            })}
        </div>
    )
}

export default ProductFeatures;